import { RouteParamType } from "../../App/Routes"

export enum ShipRoutes {
  calendar = "calendar",
  cruise = "cruise",
  edit = "edit",
  focus = "focus",
  import = "import",
  print = "print",
  printCruise = "printCruise",
  settings = "settings",
  sync = "sync",
  unknown = "unknown",
  userSwitch = "userSwitch",
}

export const ShipViewRoutes = {
  [ShipRoutes.printCruise]: {
    path: ["cruises", ":cruiseId", "print"],
    params: { cruiseId: RouteParamType.number },
  },
  [ShipRoutes.cruise]: {
    path: ["cruises", ":cruiseId"],
    params: { cruiseId: RouteParamType.number },
  },
  [ShipRoutes.edit]: {
    path: ["edit"],
  },
  [ShipRoutes.print]: {
    path: ["print"],
  },
  [ShipRoutes.focus]: {
    path: ["focus"],
  },
  [ShipRoutes.sync]: {
    path: ["sync"],
  },
  [ShipRoutes.settings]: {
    path: ["settings"],
  },
  [ShipRoutes.userSwitch]: {
    path: ["userSwitch"],
  },
  [ShipRoutes.import]: {
    path: ["import"],
  },
  [ShipRoutes.calendar]: {
    path: [""],
  },
  [ShipRoutes.unknown]: {
    path: ["*"],
  },
};
